import React, { useState } from 'react';

import { Box, Center, Loader, Paper, createStyles } from '@mantine/core';
import { Document, Page } from 'react-pdf';

const useStyles = createStyles(() => ({
  pagesContainer: {
    boxShadow: '0 2px 6px rgba(0,0,0,0.07)',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    marginBottom: '30px',
    width: 800
  },
  loaderContainer: {
    minHeight: 300,
    width: '100%',
    transition: 'all 0.3s ease'
  }
}));

export function PdfDocument({
  fileData,
  displayPageWidth,
  currentPage,
  pagesToLoad,
  onDocumentLoadSuccess
}: {
  fileData: ArrayBuffer;
  displayPageWidth: number;
  currentPage: number;
  pagesToLoad: number[];
  onDocumentLoadSuccess: (numPages: number) => void;
}) {
  const { classes } = useStyles();
  // This makes sure the pages don't flicker while the document is loading
  const [isDocumentLoading, setIsDocumentLoading] = useState(true);
  const [renderedPages, setRenderedPages] = useState<number[]>([]);

  const handleDocumentLoadSuccess = (numPages: number) => {
    onDocumentLoadSuccess(numPages);
    setIsDocumentLoading(false);
  };

  const handlePageRenderSuccess = (pageNumber: number) => {
    if (!renderedPages.includes(pageNumber)) {
      setRenderedPages((prev) => [...prev, pageNumber]);
    }
  };

  return (
    <Paper withBorder shadow="sm" className={classes.pagesContainer}>
      <Document
        file={fileData}
        onLoadSuccess={(pdfDocument) => handleDocumentLoadSuccess(pdfDocument.numPages)}
        loading={
          <Center className={classes.loaderContainer}>
            <Loader variant="dots" />
          </Center>
        }>
        {!isDocumentLoading &&
          pagesToLoad.map((pageNumber) => (
            <Box
              key={pageNumber}
              style={{
                display: pageNumber === currentPage ? 'flex' : 'none',
                // Hide until fully rendered to avoid flickering
                opacity: renderedPages.includes(pageNumber) ? 1 : 0,
                transition: 'opacity 0.3s ease'
              }}>
              <Page
                width={displayPageWidth}
                pageNumber={pageNumber}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                loading={
                  <Center className={classes.loaderContainer}>
                    <Loader size="sm" />
                  </Center>
                }
                onRenderSuccess={() => handlePageRenderSuccess(pageNumber)}
              />
            </Box>
          ))}
      </Document>
    </Paper>
  );
}
